module.exports = __webpack_public_path__ + "static/media/play-store-download.1e855277.svg";